<template>
  <v-application>
    <v-layout row class="mx-2">
      <v-flex class="px-2 pt-2" md6>
        <v-card tile outlined>
          
        </v-card>
      </v-flex>
    </v-layout>
  </v-application>
</template>

<script>
export default {
  name: 'Home',
}
</script>
